export const PAGE_SIZE = 100;
export const INITIAL_TAKE = 200;
export const ROW_HEIGHT = 35;
